import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, DAYS_YEAR, GET_AMZ_PRODUCT_URL, PAGE_SIZE } from '../../common/constants';
import { formatDateOrder, formatTo2Decimal, formatTo0Decimal, isEmpty, isEmptyArray, isNotEmpty, formatTo1Decimal, isNullCheck } from '../../common/util.services';
import { getOrder, getOrderCount, syncOrderId, syncOrderZeroValue, saveNonAmazonOrder, syncTrnStatus, syncUnitIP} from '../amazon.services';
import { Link, useLocation } from 'react-router-dom';
import { Box, Stack } from '@mui/system';
import { PlayCircleOutline } from '@mui/icons-material';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import { Grid, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';

const AmazonAllOrder = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const {state} = useLocation();
  const {orderDate} = state || {};
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let startDate = isEmpty(orderDate) ? dayjs().subtract(DAYS_YEAR, 'day') : dayjs.tz(orderDate, 'America/Los_Angeles');
  let endDate = isEmpty(orderDate) ? dayjs() : dayjs.tz(orderDate, 'America/Los_Angeles');
  const [orderId, setOrderId] = useState();
  const [rowId, setRowId] = useState(null);
  const [searchData, setSearchData] = useState<any>({zeroValue: false, zeroSalePrice: false, nonAmazon: false, product: ALL,
                                                     startDate: startDate, endDate: endDate, status: ALL});
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const [orderData, setOrderData] = useState([{rowId: '', orderId: 'Loading...'}]);
  const [orderCount, setOrderCount] = useState([]);
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>([]);
  const [openValue, setOpenValue] = useState(false);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'syncOrder', headerName: 'Sync', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }} > 
                               <PlayCircleOutline fontSize='small' color="secondary"/> </Stack>)
    },
    { field: 'orderId', headerName: 'Order Id', filterable: false, sortable: false, editable: false, width: 170,
      cellClassName: (params) => { return 'USA' !== params.row.country ? 'PerfNegative' : ''},
      renderCell: (params) => { return 'Loading...' === params.row.orderId ? 'Loading...' : (<Tooltip title={getOrdTooltip(params.row)}
      PopperProps={popperProps}>{<Link to={'https://sellercentral.amazon.com/orders-v3/order/' + params.row.orderId} 
                                 target="_blank">{params.row.orderId}</Link>}</Tooltip>)}},
    { field: 'orderDate', headerName: 'Time', filterable: false, sortable: false, editable: false, width: 170,
      valueFormatter: (value: any) => isEmpty(value) ? '' : formatDateOrder(value)
    },
    { field: 'orderGap', headerName: 'Time Gap', filterable: false, sortable: false, editable: false, width: 100},
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, editable: false, width: 80},
    { field: 'paymentStatus', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 85,
      cellClassName: (params) => { return 'Canceled' === params.row.paymentStatus || 
                                          'Refunded' === params.row.paymentStatus ? 'PerfNegative' :
                                          'Paid' === params.row.paymentStatus ? 'PerfPositive' : ''},
      renderCell: (params: any) =>  (<Tooltip title={getStatusTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{params.row.paymentStatus}</Box>}</Tooltip>)
    },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 150,
      cellClassName: (params) => { return 'Not Defined' === params.row.product || nullCheckValue(params.row) ? 'PerfNegative' : ''},
      renderCell: (params: any) =>  (<Tooltip title={params.row.color + ', ' + params.row.size}
      PopperProps={popperProps}>{<Box>{params.row.product}</Box>}</Tooltip>)
    },
    { field: 'unitInvPrice', headerName: 'Unit IP', filterable: false, sortable: false, editable: false, width: 65},
    { field: 'unitSalePrice', headerName: 'Unit SP', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => isEmpty(value) ? '' : formatTo2Decimal(value * 1),
      cellClassName: (params) => { return 0 === params.row.unitSalePrice ? 'ZeroSP' :
                                          params.row.unitInvPrice > params.row.unitSalePrice ? 'PerfNegative' : 
                                          params.row.unitInvPrice < params.row.unitSalePrice ? 'PerfPositive' : ''}
    },
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 50,
      cellClassName: (params) => { return 'Loading...' === params.row.orderId ? '' : nullCheckValue(params.row) ? 'PerfNegative' : ''}
    },
    { field: 'quantity', headerName: 'Qty', filterable: false, sortable: false, editable: false, width: 50},
    { field: 'saleValue', headerName: 'Ord Val', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  ('Loading...' === params.row.orderId ? '' : <Tooltip title={getTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{formatTo2Decimal(params.row.saleValue)}</Box>}</Tooltip>)
    },
    { field: 'fulfillmentFee', headerName: 'Fulfill', filterable: false, sortable: false, editable: false, width: 60,
      renderCell: (params: any) => 'Loading...' === params.row.orderId ? '' : formatTo2Decimal(params.row.fulfillmentFee * 1),
      cellClassName: (params) => { return ('Canceled' !== params.row.orderStatus && params.row.fulfillmentFee <= 0) ||
                                          ('Canceled' === params.row.orderStatus && params.row.fulfillmentFee > 0) ? 'PerfNegative' : ''}
    },
    { field: 'referralFee', headerName: 'Refer', filterable: false, sortable: false, editable: false, width: 60,
      renderCell: (params: any) => 'Loading...' === params.row.orderId ? '' : formatTo2Decimal(params.row.referralFee * 1),
      cellClassName: (params) => { return ('Canceled' !== params.row.orderStatus && params.row.referralFee <= 0) ||
                                          ('Canceled' === params.row.orderStatus && params.row.referralFee > 0) ? 'PerfNegative' : ''}
    },
    { field: 'lfhCost', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) => 'Loading...' === params.row.orderId ? '' : formatTo2Decimal(params.row.lfhCost * 1),
      cellClassName: (params) => { return ('Canceled' !== params.row.orderStatus && params.row.lfhCost <= 0) ||
                                          ('Canceled' === params.row.orderStatus && params.row.lfhCost > 0) ? 'PerfNegative' : ''}
    },
    { field: 'syncIP', headerName: 'IP', filterable: false, sortable: false, editable: false, width: 50,
          renderCell: (params) => (<Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }} >
                                    <PlayCircleOutline fontSize='small' color="secondary"/> </Stack>)}
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getOrderData();
    getOrderCountData();
  },[searchData, page, pageSize]);

  function getOrdTooltip(row: any) {
    let text = row.country + ',' + row.orderItemId;

    let array = text.split(',');
    array[0] = 'Country: ' + array[0];
    array[1] = 'Item Id: ' + array[1];

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function nullCheckValue(row: any) {
    return isNullCheck(row.unitCount) || isNullCheck(row.product) || isNullCheck(row.color) || isNullCheck(row.size)
  }

  function getStatusTooltip(row: any) {
    if('Refunded' !== row.paymentStatus) {
      return row.paymentStatus;
    }

    let text = row.retReason + ',' + row.retComment;

    let array = text.split(',');
    array[0] = 'Reason: ' + array[0];
    array[1] = 'Comment: ' + array[1];

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getTooltip(row: any) {
    let discountPct = formatTo2Decimal((row.unitInvPrice - row.unitSalePrice) * 100/row.unitInvPrice) + '%';
    let fulfillPct = formatTo2Decimal(row.fulfillmentFee * 100/row.saleValue) + '%';
    let referralPct = formatTo2Decimal(row.referralFee * 100/row.saleValue) + '%';
    let lfhCostPct = formatTo2Decimal(row.lfhCost * 100/row.saleValue) + '%';

    let text = discountPct + ',' + fulfillPct + ',' + referralPct + ',' + lfhCostPct;
    let array = text.split(',');
    array[0] = 'Discount: ' + array[0];
    array[1] = 'Fulfillment: ' + array[1];
    array[2] = 'Referral: ' + array[2];
    array[3] = 'LFH Cost: ' + array[3];

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getOrderData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getOrder(searchData, page, pageSize, appContext,
        (response: any) => {
          setOrderData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  function getOrderCountData() {
    setLoading(true);
    getOrderCount(searchData, appContext,
      (response: any) => {
        setOrderCount(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const onCellClick = (value: any) => {
    const field = value.field;
    setOrderId(value.row.orderId);
    if('syncOrder' === field) {
      setRowId(null);
      setShowSyncMsg(true);
    } else if('syncIP' === field) {
      setRowId(value.row.rowId);
      setShowSyncMsg(true);
    }
  }

  const onCellDoubleClick = (value: any) => {
    const field = value.field;
    setOrderId(value.row.orderId);
    if('unitSalePrice' === field) {
      setCellValueRow(value.row);
      setCellLabel('Unit Sale Price');
      openValuePopup();
    } else if('fulfillmentFee' === field) {
      setCellValueRow(value.row);
      setCellLabel('Fulfillment Fee');
      openValuePopup();
    } else if('referralFee' === field) {
      setCellValueRow(value.row);
      setCellLabel('Referral Fee');
      openValuePopup();
    } else if('quantity' === field) {
      setCellValueRow(value.row);
      setCellLabel('Quantity');
      openValuePopup();
    }
  }

  const openValuePopup = () => {
    setOpenValue(true);
  }

  const closeValuePopup = (value: any) => {
    if('Ok' === value) {
      setLoading(true);
      appContext.setShowLoader(true);
      saveNonAmazonOrder(cellValueRow, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
          setOpenValue(false);
          getOrderData();
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
          setOpenValue(false);
      });
    } else {
      setOpenValue(false);
    }
  }

  const syncOrderDataZeroValue = () => {
    setLoading(true);
    syncOrderZeroValue(appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncStatus = () => {
    setLoading(true);
    syncTrnStatus(appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onOkClick = () => {
    setLoading(true);
    if(isNotEmpty(rowId)) {
      syncUnitIP(rowId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    } else {
      syncOrderId(orderId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  const search = (data: any) => {
    setSearchData(data);
  }

  function formatPctValue(value: any) {
    return isEmpty(value) || isNaN(value) ? '' : ' (' + formatTo1Decimal(value * 1) + '%)';
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={1.5}>
          <IDateField name='startDate' label='Start Date' timeZone='America/Los_Angeles'/>
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='endDate' label='End Date' timeZone='America/Los_Angeles'/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='status' label='Status' required={true} allItemRequired={false}
            itemList={['All', 'Pending', 'Paid', 'Canceled', 'Refunded']}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='product' label='Product' required={true} allItemRequired={true} url={GET_AMZ_PRODUCT_URL}/>
        </Grid>
        <Grid xs={1.5}>
          <INumberField name='orderValue' label='Minimum Order Value'/>
        </Grid>
        <Grid xs={1.5}>
          <ITextField name='searchText' label='Search Text'/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='zeroValue' label='Zero Val' defaultChecked={false}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='zeroSalePrice' label='Zero SP' defaultChecked={false}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='nonAmazon' label='Non-Amz' defaultChecked={false}/>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={3}>
            <IReadOnlyField label='Order #' value={formatTo0Decimal(orderCount[0])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Inv Price' value={formatTo0Decimal(orderCount[3])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Ord Val' value={formatTo0Decimal(orderCount[4])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Discount' value={formatTo1Decimal(orderCount[5]) + '%'}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Cancellation' value={formatTo0Decimal(orderCount[1]) + formatPctValue(orderCount[2])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Refund #' value={formatTo0Decimal(orderCount[16]) + formatPctValue(orderCount[17])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Refund' value={formatTo0Decimal(orderCount[18]) + formatPctValue(orderCount[19])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Fulfill' value={formatTo0Decimal(orderCount[6]) + formatPctValue(orderCount[7])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Referral' value={formatTo0Decimal(orderCount[8]) + formatPctValue(orderCount[9])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='LFH Cost' value={formatTo0Decimal(orderCount[10]) + formatPctValue(orderCount[11])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Oth Gain' value={formatTo0Decimal(orderCount[12]) + formatPctValue(orderCount[13])}/>
          </Grid>
          <Grid xs={3}>
            <IReadOnlyField label='Gross' value={formatTo0Decimal(orderCount[14]) + formatPctValue(orderCount[15])}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={orderData} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          showExtBtn={true} extBtnText={'Sync Zero Value'} extBtnAction={syncOrderDataZeroValue}
          showExtBtn2={false} extBtn2Text={'Sync Trn Status'} extBtn2Action={syncStatus}
          getRowId={(row: any) => row.rowId} cellClick={onCellClick} cellDoubleClick={onCellDoubleClick}
          showAction={false} showApproveAction={false} showDeleteAction={false} showEditAction={false} />
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
                onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
                message={'Do you want to sync data?'}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Value'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
    </>
  }

  return <TitlePanel title='All Order' panelBody={getMainPanel()} />
}

export default AmazonAllOrder;